export default __webpack_public_path__ + "static/media/img-pressRoom.fada431c.jpg";